import { render, staticRenderFns } from "./GenericGridAddNewCard.vue?vue&type=template&id=02b79a0c&scoped=true&"
import script from "./GenericGridAddNewCard.vue?vue&type=script&lang=ts&"
export * from "./GenericGridAddNewCard.vue?vue&type=script&lang=ts&"
import style0 from "./GenericGridAddNewCard.vue?vue&type=style&index=0&id=02b79a0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b79a0c",
  null
  
)

export default component.exports